import React from "react";
import { Text, View } from "react-native";
import { useRsvpColors } from "../theme";
import RsvpStatusIcon, { RsvpIconName } from "./RsvpStatusIcon";

interface Props {
  icon: RsvpIconName;
  title: string;
  body: string;
}

/**
 * Inline "nothing to do here" state for the personal RSVP page: the player has
 * no reservation and cannot make one (window closed, event full, not eligible).
 * Rendered inside the page scaffold, unlike RsvpMessage which is a full page.
 */
const RsvpClosedState: React.FC<Props> = ({ icon, title, body }) => {
  const colors = useRsvpColors();
  return (
    <View style={{ alignItems: "center", paddingVertical: 16 }}>
      <View style={{ marginBottom: 12 }}>
        <RsvpStatusIcon name={icon} tone="neutral" />
      </View>
      <Text
        style={{
          color: colors.textSecondary,
          fontSize: 24,
          fontWeight: "700",
          textAlign: "center",
          marginBottom: 8,
        }}
      >
        {title}
      </Text>
      <Text
        style={{
          color: colors.textFaint,
          fontSize: 15,
          textAlign: "center",
        }}
      >
        {body}
      </Text>
    </View>
  );
};

export default RsvpClosedState;
